import { ApolloQueryResult, FetchResult } from "@apollo/client/core";
import { generateApolloClient } from "@/common/apolloClientUtil";
import {
  localStorageGetChainCode,
  localStorageGetCustomerCode,
} from "@/common/localStorageUtil";
import { getWordList } from "@/common/graphql/expression";
import {
  CreateFixturesOrderDocument,
  CreateFixturesOrderMutation,
  CreateFixturesOrderMutationVariables,
  ListFixturesDocument,
  ListFixturesQuery,
  ListFixturesQueryVariables,
} from "@/generated/graphql";
import { FIXTURES_REGISTER_FILE_NAME } from "../constants";

/**
 * 資材発注登録画面のAPI呼び出しを扱う composable。
 */
export const useFixturesRegisterApi = () => {
  /**
   * 画面文言を取得する。
   */
  const fetchWordList = async (): Promise<Record<string, string>> => {
    return getWordList(
      localStorageGetChainCode(),
      FIXTURES_REGISTER_FILE_NAME,
      localStorageGetCustomerCode()
    );
  };

  /**
   * 資材一覧を取得する。
   */
  const fetchFixtures = async (): Promise<ApolloQueryResult<ListFixturesQuery>> => {
    const apolloClient = await generateApolloClient();
    return apolloClient.query<ListFixturesQuery, ListFixturesQueryVariables>({
      query: ListFixturesDocument,
      variables: {
        chain_code: localStorageGetChainCode(),
        customer_code: localStorageGetCustomerCode(),
      },
      fetchPolicy: "no-cache",
    });
  };

  /**
   * 資材発注を登録する。
   */
  const createFixturesOrder = async (
    input: CreateFixturesOrderMutationVariables["input"]
  ): Promise<FetchResult<CreateFixturesOrderMutation>> => {
    const apolloClient = await generateApolloClient();
    return apolloClient.mutate<
      CreateFixturesOrderMutation,
      CreateFixturesOrderMutationVariables
    >({
      mutation: CreateFixturesOrderDocument,
      variables: {
        input,
      },
    });
  };

  return {
    fetchWordList,
    fetchFixtures,
    createFixturesOrder,
  };
};
